// import Assignment from './Assignment';

export default {
  priority: 2,
  // component: Assignment,
  component: load(() =>
    import(/* webpackChunkName: "Requests-Pattern-Assignment" */ "./Assignment")
  ),
  name: app.translate("routes.home.requests.Assignment"),
  path: "assignment",
  permissions: ["TimeAttendanceMenu/SmsMenu/SmsAssignmentMenu"],
  icon: "account-check",
  drawer: true,
};
